/* eslint-disable linebreak-style */
import React from 'react';
const LeaveOfAbsenceStepShared = () => (
  <ol>
    <li>
    Attach a copy of your approved leave notice, that shows your employer’s name, address, and contact information for the approving person.
    </li>
    <li>
    Proof of Outstanding Dues (invoice or other documentation received from developer)
    </li>
  </ol>
);

export default LeaveOfAbsenceStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/components/LeaveOfAbsenceStepShared.js